// src/pages/RegisterPage.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useApi } from '../hooks/useApi';
import logoLogin from '../assets/beo-logo-login.png';

export default function RegisterPage({ showToast }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('employee');
  const navigate = useNavigate();
  const { request, loading } = useApi();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await request('/api/register', {
        method: 'POST',
        body: JSON.stringify({ username, password, role }),
      });
      showToast('Registration successful! Please login.', 'success');
      navigate('/login');
    } catch (err) {
      showToast(err.message || 'Registration failed', 'error');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-image">
        <div className="auth-image-content">
          <img src={logoLogin} alt="BEO IT Operations Logo" style={{ width: '100%', maxWidth: '240px', marginBottom: '16px', filter: 'drop-shadow(0 0 15px var(--white-20))' }} />
          <h1 style={{ fontSize: '24px', fontWeight: 'bold', margin: '0 0 8px 0' }}>BEO Helpdesk</h1>
          <p>Enterprise Helpdesk Platform by BEO Software</p>
        </div>
      </div>
      <div className="auth-form-card">
        <form className="auth-card" onSubmit={handleSubmit}>
          <h2>Create Account</h2>
          <p className="auth-subtitle">Get started with your new account.</p>

          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Role</label>
            <select
              className="form-control"
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option value="employee">Employee</option>
              <option value="it">IT Support</option>
              <option value="admin">Administrator</option>
            </select>
          </div>

          <button className="btn btn-primary w-full" type="submit" disabled={loading}>
            {loading ? 'Registering...' : 'Register'}
          </button>

          <div className="auth-footer">
            Already have an account? <Link to="/login">Sign In</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
